import styled from 'styled-components';
import { gray20, gray90, spacer24, spacer32, spacer48 } from '@spotify-internal/encore-foundation';

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.dialogFullScreen === 'dark';
};

export default styled.div.withConfig({
  displayName: "Body",
  componentId: "sc-1rspgw4-0"
})(["border-bottom:1px solid ", ";flex:1;-ms-overflow-style:-ms-autohiding-scrollbar;overflow-x:hidden;overflow-y:auto;padding:", " ", " ", ";"], function (props) {
  return isDarkTheme(props) ? gray20 : gray90;
}, spacer32, spacer24, spacer48);